import { lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { DeferredSection } from '@/components/common/DeferredSection';
import { Seo } from '@/components/common/Seo';
import { AboutPreviewSection } from '@/components/home/AboutPreviewSection';
import { FeaturedServicesSection } from '@/components/home/FeaturedServicesSection';
import { HeroSection } from '@/components/home/HeroSection';

const ProjectsSection = lazy(() =>
  import('@/components/home/ProjectsSection').then(module => ({
    default: module.ProjectsSection
  }))
);
const WhyChooseUsSection = lazy(() =>
  import('@/components/home/WhyChooseUsSection').then(module => ({
    default: module.WhyChooseUsSection
  }))
);
const TestimonialsSection = lazy(() =>
  import('@/components/home/TestimonialsSection').then(module => ({
    default: module.TestimonialsSection
  }))
);
const ContactSection = lazy(() =>
  import('@/components/home/ContactSection').then(module => ({
    default: module.ContactSection
  }))
);

export default function Home() {
  const { hash } = useLocation();

  return (
    <>
      <Seo
        title="Početna"
        description="Helmflex planira i vodi poslovne projekte za mala i srednja preduzeća, od definisanja obima do praćenja realizacije."
      />
      <HeroSection />
      <AboutPreviewSection />
      <FeaturedServicesSection />
      <DeferredSection
        placeholderClassName="min-h-[1500px] md:min-h-[1350px] lg:min-h-[1250px]"
        forceRender={hash === '#projekti'}
      >
        <ProjectsSection />
      </DeferredSection>
      <DeferredSection placeholderClassName="min-h-[1050px] lg:min-h-[900px]">
        <WhyChooseUsSection />
      </DeferredSection>
      <DeferredSection
        placeholderClassName="min-h-[1050px] lg:min-h-[850px]"
        forceRender={hash === '#iskustva'}
      >
        <TestimonialsSection />
      </DeferredSection>
      <DeferredSection
        placeholderClassName="min-h-[1450px] lg:min-h-[1050px]"
        forceRender={hash === '#home-kontakt'}
      >
        <ContactSection />
      </DeferredSection>
    </>
  );
}
